var OverviewTotal = /** @class */ (function () {
    function OverviewTotal(overview) {
        this.overview = overview;
    }
    OverviewTotal.prototype.total = function () {
        return this.overview.approval +
            this.overview.comparison +
            this.overview.research +
            this.overview.amend +
            this.overview.input +
            this.overview.live;
    };
    return OverviewTotal;
}());
export { OverviewTotal };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3ZlcnZpZXctdG90YWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJvdmVydmlldy10b3RhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtJQUNJLHVCQUFvQyxRQUFpQztRQUFqQyxhQUFRLEdBQVIsUUFBUSxDQUF5QjtJQUFJLENBQUM7SUFFbkUsNkJBQUssR0FBWjtRQUNJLE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRO1lBQ3pCLElBQUksQ0FBQyxRQUFRLENBQUMsVUFBVTtZQUN4QixJQUFJLENBQUMsUUFBUSxDQUFDLFFBQVE7WUFDdEIsSUFBSSxDQUFDLFFBQVEsQ0FBQyxLQUFLO1lBQ25CLElBQUksQ0FBQyxRQUFRLENBQUMsS0FBSztZQUNuQixJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQztJQUMzQixDQUFDO0lBQ0wsb0JBQUM7QUFBRCxDQUFDLEFBWEQsSUFXQyJ9